import React from 'react'
import MakeHomepage from '../make-homepage'

const MakeHomepageEs = () => {
    return <MakeHomepage languageCode="es" />
}

export default MakeHomepageEs
